import React from 'react';
import {Input} from 'semantic-ui-react';

import './index.css';

export class ChatedInput extends React.Component {
	focus = () => {
		this.input.focus();
	}

	render () {
		return (
			<Input { ...this.props } className={ `${ this.props.className } chatedio-input` } ref={el => (this.input = el)} />
		);
	}
}

export default ChatedInput;



// WEBPACK FOOTER //
// ./src/components/forms/textbox/index.js